import { render } from "./LayoutSegmentHolder.vue?vue&type=template&id=b4b3fcb6&scoped=true"
import script from "./LayoutSegmentHolder.vue?vue&type=script&lang=js"
export * from "./LayoutSegmentHolder.vue?vue&type=script&lang=js"

import "./LayoutSegmentHolder.vue?vue&type=style&index=0&id=b4b3fcb6&lang=css"
import "./LayoutSegmentHolder.vue?vue&type=style&index=1&id=b4b3fcb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b3fcb6"]])

export default __exports__